import { checkVersion } from '@/apis/softwareUpdate'
import { datafluxRum } from '@cloudcare/browser-rum'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export const initRum = () => {
  // console.log('datafluxRum init start', datafluxRum.getInitConfiguration())

  const env = import.meta.env.VITE_APP_ENV as string
  if (env === 'dev') {
    return
  }
  const envMap = {
    production: {
      applicationId: 'kehuzhitongche',
      site: 'https://dataway.guance.kone.cn',
      clientToken: 'efdb04d8105a496aac406a02d5ad09b2'
    },
    acc: {
      applicationId: 'kehuzhitongche',
      site: 'https://dataway.guance.kone.cn',
      clientToken: 'ab9fa29fad2548d4a91ce8b667c11e8b'
    }
    // dev: {
    //   applicationId: 'kedex_dev_demo',
    //   site: 'https://dataway.guance.kone.cn',
    //   clientToken: 'ff53d495306046ea84d973522db48052'
    // }
  }
  const applicationId = datafluxRum.getInitConfiguration()?.['applicationId']
  //防重复初始化
  if (applicationId && applicationId == envMap[env].applicationId) {
    return
  }
  checkVersion().then((res) => {
    if (res && res.code == '200') {
      const appVersion = res.data.curAppVersion ?? __APP_INFO__.pkg.version
      const config = envMap[env]
      datafluxRum.init({
        applicationId: config.applicationId,
        site: config.site,
        clientToken: config.clientToken,
        env,
        version: appVersion,
        service: 'browser',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 70,
        trackInteractions: true,
        traceType: 'ddtrace', // 非必填，默认为ddtrace，目前支持 ddtrace、zipkin、skywalking_v3、jaeger、zipkin_single_header、w3c_traceparent 6种类型
        allowedTracingOrigins: ['http://localhost:8020', /https:\/\/.*\.kone\.cn/] // 非必填，允许注入trace采集器所需header头部的所有请求列表。可以是请求的origin，也可以是是正则
      })
      FingerprintJS.load().then((fp) => {
        fp.get().then((result) => {
          // console.log('======FingerprintJS======', result.visitorId)
          datafluxRum.setGlobalContextProperty('fingerPrint', result.visitorId)
        })
      })
      datafluxRum.startSessionReplayRecording()
    }
  })
}

export const setRumUserContext = (data) => {
  const userInfo = {
    id: data.onlineUserId,
    name: data.onlineUsername,
    masterAccountFlag: data.masterAccountFlag
  }
  datafluxRum.setUser(userInfo)
  datafluxRum.setGlobalContextProperty('userInfo', userInfo)
}

export const setRumUserLogout = () => {
  datafluxRum.clearUser()
  datafluxRum.removeGlobalContextProperty('userInfo')
}
